var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00CEFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,256c44.1,0,80-35.9,80-80s-35.9-80-80-80s-80,35.9-80,80S131.9,256,176,256z M528,128H304 c-8.8,0-16,7.2-16,16v144H64V80c0-8.8-7.2-16-16-16H16C7.2,64,0,71.2,0,80v352c0,8.8,7.2,16,16,16h32c8.8,0,16-7.2,16-16v-48h512v48 c0,8.8,7.2,16,16,16h32c8.8,0,16-7.2,16-16V240C640,178.1,589.9,128,528,128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedSolid);
export default __webpack_public_path__ + "static/media/bed-solid.c6e9624addbc19550f2a038d37c6f8cb.svg";
export { ForwardRef as ReactComponent };